import React from 'react';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ImageView from './Image';
import JournalView from './Journal';
import LiteratureView from './Literature';
import StatusView from './Status';
import TierView from './Tier';
import CommissionView from './Commission';
import UnknownView from './Unknown';
const DaEditorMonoView = (props)=>{
    let View;
    switch(getDeviationType(props.deviation)){
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            View = ImageView;
            break;
        case DeviationTypes.STATUS:
            View = StatusView;
            break;
        case DeviationTypes.LITERATURE:
            View = LiteratureView;
            break;
        case DeviationTypes.JOURNAL:
            View = JournalView;
            break;
        case DeviationTypes.TIER:
            View = TierView;
            break;
        case DeviationTypes.COMMISSION:
            View = CommissionView;
            break;
        default:
            View = UnknownView;
    }
    return /*#__PURE__*/ React.createElement(View, props);
};
DaEditorMonoView.displayName = 'DaEditorMonoView';
export default DaEditorMonoView;
